import React, { useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import * as R from 'ramda'
import Page from '../../../../component/page'
import CountryMap from '../../CountryMap'
import CourseTable from '../../CourseTable'
import { isAdmin } from '../../isAdmin'
import {
  filterAll,
  filterIsSmall,
  filterIsLarge,
  filterIsPrivate,
  filterIsActive,
  filterHasLocation,
  filterWrongHoleCount,
  filterIsZombieCourse,
  filterHasInvalidCountryAndState,
} from '../../CourseFilters'
import {
  groupFilterSingle,
  groupFilterMultiple,
  groupFilterMixedPrivate,
  groupFilterBecamePrivate,
  groupFilterProblematic,
  groupFilterLarge,
  groupFilterLargeActive,
  groupFilterWithLocation,
  groupFilterHasSomeZombieCourses,
  groupFilterHasOnlyZombieCourses,
} from '../../GroupFilters'

function numberWithSpaces(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
}

const percent = (tot, frac) => {
  return tot === 0 || frac === undefined
    ? 'Pending'
    : ((frac * 100) / tot).toFixed(2) + '%'
}

function CourseManager(props) {
  const {
    user,
    courses,
    groupedCourses,
    uniqeCoursesByName,
    isLoadingCourses,
  } = props
  const dispatch = useDispatch()

  const [courseFilter, setCourseFilter] = useState(() => filterAll)
  const [groupFilter, setGroupFilter] = useState(() => filterAll)
  const [filteredCourses, setFilteredCourses] = useState(courses)

  const refreshData = () => {
    const hasNoCourses = courses.length === 0
    const isNotLoadingCourses = !isLoadingCourses
    if (isAdmin(user) && hasNoCourses && isNotLoadingCourses) {
      dispatch({
        type: 'ADMIN_LOAD_ALL_COURSES',
        payload: {
          request: {
            url: `/admin/all`,
          },
        },
      })
    }
  }

  useEffect(() => {
    refreshData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user, courses])

  useEffect(() => {
    console.log('onCoursesChanged', groupedCourses.length)
    const _filteredCourses = groupedCourses
      .filter(groupFilter)
      .flatMap((group) => group)
      .filter(courseFilter)
    setFilteredCourses(_filteredCourses)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [groupedCourses])

  const setFilter = (courseFilter, groupFilter) => {
    const _filteredCourses = groupedCourses
      .filter(groupFilter)
      .flatMap((group) => group)
      .filter(courseFilter)

    setCourseFilter(() => courseFilter)
    setGroupFilter(() => groupFilter)
    setFilteredCourses(_filteredCourses)
  }

  const renderCourseFilterButton = (title, filterFn) => {
    const filteredCourses = courses.filter(filterFn)
    const filteredActive = filteredCourses.filter(filterIsActive)

    console.log(title, filteredCourses.length, 'Active', filteredActive.length)
    const className =
      'btn btn-small btn-' +
      (courseFilter === filterFn ? 'success' : 'primary')
    return (
      <div>
        <button
          onClick={() => setFilter(filterFn, groupFilter)}
          className={className}
        >
          <b>{title}:</b> {numberWithSpaces(filteredCourses.length)}
          {'  '}({percent(courses.length, filteredCourses.length)}){'  '}
          {numberWithSpaces(filteredActive.length)}
          {'  '}({percent(courses.length, filteredActive.length)})
        </button>
      </div>
    )
  }

  const renderFmtCourses = (title, filteredCourses) => {
    const filteredActive = filteredCourses.filter(filterIsActive)
    console.log(title, filteredCourses.length, 'Active', filteredActive.length)
    return (
      <div>
        <b>{title}:</b> {numberWithSpaces(filteredCourses.length)}
        {'  '}({percent(courses.length, filteredCourses.length)}){'  '}
        {numberWithSpaces(filteredActive.length)}
        {'  '}({percent(courses.length, filteredActive.length)})
      </div>
    )
  }

  const renderFmtValue = (title, value) => {
    console.log(title, value)
    return (
      <div>
        <b>{title}:</b> {numberWithSpaces(value)}
        {'  '}({percent(courses.length, value)})
      </div>
    )
  }

  const renderGroupFmt = (title, _groupFilter) => {
    const filteredGroups = groupedCourses.filter(_groupFilter)
    console.log('filteredGroups', filteredGroups)
    const filteredGroupsWithCourseFilter = filteredGroups
      .map((c) => c.filter(courseFilter))
      .filter((g) => g.length > 0)
    const filteredGroupsWithCourseFilterAndActive =
      filteredGroupsWithCourseFilter
        .map((c) => c.filter(filterIsActive))
        .filter((g) => g.length > 0)

    const className =
      'btn btn-small btn-' +
      (groupFilter === _groupFilter ? 'success' : 'primary')

    return (
      <div className="group-buttons">
        <button
          onClick={() => setFilter(courseFilter, _groupFilter)}
          className={className}
        >
          <b>Group {title}:</b> {numberWithSpaces(filteredGroups.length)}
          {'  '}({percent(groupedCourses.length, filteredGroups.length)})
        </button>
        <button
          onClick={() => setFilter(courseFilter, _groupFilter)}
          className={className}
        >
          <b>With coursefilter:</b>{' '}
          {numberWithSpaces(filteredGroupsWithCourseFilter.length)}
          {'  '}(
          {percent(
            groupedCourses.length,
            filteredGroupsWithCourseFilter.length
          )}
          )
        </button>
        <button
          onClick={() => setFilter(courseFilter, _groupFilter)}
          className={className}
        >
          <b>Active non private:</b>{' '}
          {numberWithSpaces(filteredGroupsWithCourseFilterAndActive.length)}
          {'  '}(
          {percent(
            groupedCourses.length,
            filteredGroupsWithCourseFilterAndActive.length
          )}
          )
        </button>
      </div>
    )
  }

  if (!isAdmin(user)) return null

  return (
    <>
      <Page className="container admin" hideAds>
        <div className="row">
          <div className="col-sm-12">
            <div>
              <h1>Admin {isLoadingCourses && ' is loading...'}</h1>
              {renderCourseFilterButton('All Courses', filterAll)}
              {renderCourseFilterButton('Active', filterIsActive)}
              {renderCourseFilterButton('Private', filterIsPrivate)}
              {renderCourseFilterButton(
                'Has invalid Country and State',
                filterHasInvalidCountryAndState
              )}
              {renderCourseFilterButton('With Location', filterHasLocation)}
              <span>&nbsp;</span>
              {renderCourseFilterButton(
                'Wrong hole count',
                filterWrongHoleCount
              )}
              {renderCourseFilterButton('Zombie', filterIsZombieCourse)}
              {renderCourseFilterButton('Small', filterIsSmall)}
              {renderCourseFilterButton('Large', filterIsLarge)}
              <span>&nbsp;</span>
              {renderFmtValue('Grouped', groupedCourses.length)}
              <span>&nbsp;</span>
              {renderGroupFmt('Single', groupFilterSingle)}
              {renderGroupFmt('Multiple', groupFilterMultiple)}
              {renderGroupFmt('Mixed With Private', groupFilterMixedPrivate)}
              {renderGroupFmt(
                'Became Private Problem',
                groupFilterBecamePrivate
              )}
              {renderGroupFmt('Problems', groupFilterProblematic)}
              {renderGroupFmt('Large', groupFilterLarge)}
              {renderGroupFmt('Large active', groupFilterLargeActive)}
              {renderGroupFmt('Has Location', groupFilterWithLocation)}
              {renderGroupFmt(
                'Has Some Zombie Curses',
                groupFilterHasSomeZombieCourses
              )}
              {renderGroupFmt(
                'Has Only Zombie Curses',
                groupFilterHasOnlyZombieCourses
              )}
              <span>&nbsp;</span>
              {renderFmtCourses('Unique by Name', uniqeCoursesByName)}
              {renderFmtCourses(
                'Unique by Name and Country',
                R.uniqBy(
                  (course) =>
                    (course.country || {}).name +
                    ':' +
                    course.name.toLowerCase(),
                  courses
                )
              )}
              <span>&nbsp;</span>
              {renderFmtCourses('Listed / Filtered Curses', filteredCourses)}
              <h2>Map</h2>
              <CountryMap courses={filteredCourses} />
              <h2>Courses</h2>
            </div>
          </div>
        </div>
      </Page>
      <CourseTable
        courses={filteredCourses}
        uniqeCoursesByName={uniqeCoursesByName}
        onClicked={console.log}
        initialSort={[
          { key: 'groupId', order: 'desc' },
          { key: 'updated', order: 'desc' },
        ]}
      />
    </>
  )
}

const mapStateToProps = (state) => {
  const { courses, groupedCourses, uniqeCoursesByName, isLoadingCourses } =
    state.admin
  return {
    user: state.auth.user,
    courses,
    groupedCourses,
    uniqeCoursesByName,
    isLoadingCourses,
  }
}

export default connect(mapStateToProps)(CourseManager)
